import { checkFieldCondition } from './actionHelper'
import { isChecklistField } from './checklistHelper'
import type { DynamicField } from '../types'

export const buildDefaults = (fields?: Array<DynamicField>) =>
  fields?.reduce<Record<string, unknown>>((acc, f) => {
    acc[f.param_key || ''] = isChecklistField(f) ? [] : (f.default ?? '')

    return acc
  }, {})

const isEmptyValue = (value: unknown) =>
  value === '' || value === null || typeof value === 'undefined' || (Array.isArray(value) && !value.length)

export const buildSubmitPayload = (fields: Array<DynamicField> | undefined, values: Record<string, unknown>) => {
  const hiddenKeys = new Set(
    (fields ?? [])
      .filter((f) => 'visible_if' in f && f.visible_if && !checkFieldCondition(values, f.visible_if))
      .map((f) => f.param_key || ''),
  )

  return Object.entries(values).reduce<Record<string, unknown>>((acc, [key, value]) => {
    if (!hiddenKeys.has(key) && !isEmptyValue(value)) acc[key] = value

    return acc
  }, {})
}
